"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./lib/ActorInitSparql-browser"));
var actor_sparql_serialize_tree_1 = require("@comunica/actor-sparql-serialize-tree");
exports.bindingsStreamToGraphQl = actor_sparql_serialize_tree_1.bindingsStreamToGraphQl;
/**
 * Create a new comunica engine from the default config.
 * @return {ActorInitSparql} A comunica engine.
 */
function newEngine() {
    return require('./engine-default.js');
}
exports.newEngine = newEngine;
// TODO: remove in 2.0.0, this is just here for backwards-compatibility
function evaluateQuery(query, context) {
    return newEngine().query(query, context);
}
exports.evaluateQuery = evaluateQuery;
//# sourceMappingURL=index-browser.js.map